import { render, staticRenderFns } from "./SetClientModal.vue?vue&type=template&id=640c5709&scoped=true&"
import script from "./SetClientModal.vue?vue&type=script&lang=js&"
export * from "./SetClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640c5709",
  null
  
)

export default component.exports